export default __webpack_public_path__ + "static/media/c6e7ca0482a4e7fa182a3428d1ce99e91599170809333.1fbefda2.webp";